import { TFunction } from 'i18next'
import { EUserRoles } from 'types/users'
import { z } from 'zod'

const roles = [
  EUserRoles.COMMISSION_MEMBER,
  EUserRoles.COMMITTEE_MEMBER,
  EUserRoles.PROCUREMENT_SPECIALIST,
  EUserRoles.ISP_SPECIALIST,
  EUserRoles.ADMIN,
  EUserRoles.SUPER_ADMIN,
  EUserRoles.USER,
] as const

export const createUserFormSchema = (t: TFunction) =>
  z.object({
    firstName: z.string().min(1, {
      message: t('required'),
    }),
    lastName: z.string().min(1, {
      message: t('required'),
    }),
    position: z.string(),
    countryCode: z.string().regex(new RegExp(/^[A-Z]{3}$/), {
      message: t('isoCode'),
    }),
    phoneNumber: z.string().regex(new RegExp(/^\d{1,32}$/), {
      message: t('phone-error-code'),
    }),
    identityCardSeries: z.string().min(1, {
      message: t('required'),
    }),
    identityCardNumber: z.string().min(1, {
      message: t('required'),
    }),
    personalIdentificationNumber: z
      .string()
      .max(7)
      .min(7, {
        message: t('required'),
      }),

    email: z.string().email({ message: t('invalidEmail') }),
    userRoles: z.enum(roles).array(),
  })
